// extracted by mini-css-extract-plugin
export var alignCenter = "_bd-d";
export var bannerShown = "_bd-6";
export var buttonContent = "_bd-0";
export var cardList = "_bd-1";
export var centerContent = "_bd-2";
export var chevron = "_bd-3";
export var closePanelButton = "_bd-k";
export var conversationContextContainer = "_bd-l";
export var conversationDetailContainer = "_bd-4";
export var detailWrapper = "_bd-7";
export var dropdownButton = "_bd-e";
export var dropdownTitle = "_bd-9";
export var fullHeight = "_bd-5";
export var hidden = "_bd-a";
export var icon = "_bd-b";
export var mergeSuggestionWrapper = "_bd-m";
export var panel = "_bd-i";
export var portalButtonsWrapper = "_bd-c";
export var right = "_bd-j";
export var tableSummaryContainer = "_bd-8";
export var tableSummaryHeader = "_bd-g";
export var threeDotsButton = "_bd-f";
export var wide = "_bd-h";